export const WSDataType = {
	ACTIVE_TRANSACTION: 0,
	DOOR_UNLOCKED: 1,
	DOOR_LOCKED: 2,
	DOOR_OPENED: 3,
	DISH_REMOVED: 4,
	DOOR_CLOSED: 5,
	FINISHED_TRANSACTION: 6,
	QR_CODE: 7,
	REFILL_STARTED: 8,
	REFILL_FINISHED: 9,
} as const;

export type WSDataType = (typeof WSDataType)[keyof typeof WSDataType];

export const WSDataVariant = {
	EMPTY: 0,
	SMALL_ORDER: 1,
	LARGE_ORDER: 2,
	NATIVE_PAYMENT: 3,
	EMPTY_ORDER_START: 4,
} as const;

export type WSDataVariant = (typeof WSDataVariant)[keyof typeof WSDataVariant];

export type WSMessage = { type: WSDataType; variant?: WSDataVariant };
